"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
function Connect() {
    function stateAndDispatch(mapStateToProps, mapDispatchToProps) {
        var connector = react_redux_1.connect(mapStateToProps, mapDispatchToProps);
        function withComp(comp) {
            var result = connector(comp); // can't figure out this one in due time
            return result;
        }
        return { withComp: withComp };
    }
    return { stateAndDispatch: stateAndDispatch };
}
exports.Connect = Connect;
//# sourceMappingURL=Connect.js.map